<template>
  <div>
    <v-snackbar
      top
      :timeout="message.timeout"
      class="message"
      :class="[navbar && 'navbar', `${message.mode}-mode`]"
      :value="message.text"
      :color="messageColor"
    >
      <v-icon class="mr-4 flex-shrink-0 flex-grow-0">{{ messageIcon }}</v-icon>
      <span v-html="message.text" class="text-center" />
    </v-snackbar>

    <v-dialog
      @input="!$event && cancelAlert()"
      :value="alert"
      width="672"
      v-if="alert"
    >
      <v-card class="pa-6">
        <v-card-title class="justify-center pa-0 mb-6">
          <v-icon size="48" color="#FE285B">mdi-alert-rhombus</v-icon>
          <v-btn icon absolute top right @click="cancelAlert">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-title v-if="alert.title" class="alert-title pa-0 mb-3">
          {{ alert.title }}
        </v-card-title>
        <v-card-text
          v-if="alert.description"
          class="alert-description pa-0 mb-8"
        >
          {{ alert.description }}
        </v-card-text>

        <!-- this component will not get rendered when alert.form does not exist -->
        <component
          :is="alert.form"
          v-model="alertFormData"
          @valid="alertFormValid = $event"
        />

        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="text-decoration-underline mr-2"
            @click="cancelAlert"
            v-if="alert.cancelText"
          >
            {{ alert.cancelText }}
          </v-btn>

          <v-btn
            color="primary"
            class="px-4"
            :disabled="!alertFormValid"
            @click="
              alert.actionFn && alert.actionFn(alertFormData);
              setAlert(null);
            "
          >
            {{ alert.actionText || "OK" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog :value="paymentDialog" persistent max-width="666">
      <foldable-card
        title="View or Edit Payment Method"
        non-foldable
        hide-border
        @closing="paymentDialog = false"
      >
        <payment-options
          location="Account Payment"
          :key="paymentSessionId"
          @has-payment="$event === true && (paymentDialog = false)"
          @has-dialog="paymentDialog = $event !== true"
        ></payment-options>
      </foldable-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import FoldableCard from "@/components/FoldableCard";
import PaymentOptions from "@/components/PaymentOptions";

const { mapState, mapMutations } = createNamespacedHelpers("notification");

const colorMap = {
  success: "colorSemanticStateGreen100",
  error: "colorSemanticStateRed100",
  warning: "colorSemanticStateYellow100",
  info: "colorPtBlue100"
};

const iconMap = {
  success: "$success",
  error: "$error",
  warning: "$warning",
  info: "$info"
};

export default {
  name: "Notification",
  props: ["navbar"],
  data: () => ({
    alertFormValid: true,
    alertFormData: null
  }),
  computed: {
    ...mapState(["message", "alert", "paymentSessionId", "timeout"]),
    paymentDialog: {
      get() {
        return this.$store.state.notification.paymentDialog;
      },
      set(val) {
        this.$store.commit("notification/updatePaymentDialog", val);
      }
    },
    messageColor() {
      return this.message && colorMap[this.message.mode];
    },
    messageIcon() {
      return this.message && iconMap[this.message.mode];
    }
  },
  methods: {
    ...mapMutations(["setAlert"]),
    cancelAlert() {
      this.alert.cancelFn && this.alert.cancelFn();
      this.setAlert(null);
    }
  },
  components: {
    PaymentOptions,
    FoldableCard
  }
};
</script>
<style lang="sass" scoped>
::v-deep .v-snack__wrapper
  min-height: 55px
  height: auto
  box-shadow: 1px 3px 12px 0 rgba(18, 40, 70, 0.1), 0 0 1px 0 rgba(18, 40, 70, 0.3)
  .v-snack__content
    justify-content: center

::v-deep .v-snack
  font-size: 14px
  font-weight: 400
  .v-icon
    font-size: 18px
  &.info-mode
    .v-snack__wrapper
      color: $color-pt-blue-800 !important
      background-color: $color-pt-blue-100 !important
    .v-icon
      color: $color-pt-blue-500 !important
  &.success-mode
    .v-snack__wrapper
      color: $color-semantic-state-green-800 !important
      background-color: $color-semantic-state-green-100 !important
    .v-icon
      color: $color-semantic-state-green-500 !important
  &.warning-mode
    .v-snack__wrapper
      color: $color-semantic-state-yellow-800 !important
      background-color: $color-semantic-state-yellow-200 !important
    .v-icon
      color: $color-semantic-state-yellow-500 !important
  &.error-mode
    .v-snack__wrapper
      color: $color-semantic-state-red-800 !important
      background-color: $color-semantic-state-red-100 !important
    .v-icon
      color: $color-semantic-state-red-500 !important

.message
  &.navbar
    margin-top: 96px //for navbar
  ::v-deep .v-snack__wrapper
    max-width: 848px

.alert-title
  color: $grey-text-color
  font-weight: normal !important
.alert-description
  color: #4b4b4b !important
</style>
